import * as React from "react"
import { useState } from "react"
import Chart from "../pages/index/Chart"

export interface IAvailabilityIndicatorProps {
  facilityName: string;
  estimatedParkingSpacesAvailable: number
  parkingSpacesTotal: number
}

export function AvailabilityIndicator(props: IAvailabilityIndicatorProps) {
  const { facilityName, estimatedParkingSpacesAvailable, parkingSpacesTotal } = props
  const [shouldDisplayBig, setShouldDisplayBig] = useState<boolean>(false)

  if (estimatedParkingSpacesAvailable === undefined) {
    return <></>
  }

  let percentageAvailable =
    parkingSpacesTotal === 0
      ? 0
      : Math.round((estimatedParkingSpacesAvailable / parkingSpacesTotal) * 100)

  return (
    <div
      onClick={() => setShouldDisplayBig(!shouldDisplayBig)}
      className={shouldDisplayBig ? "big" : "small"}
    >
      <span className="facility-name">{facilityName}</span>&nbsp;
      <span className="text-center">
        Available: {estimatedParkingSpacesAvailable} / {parkingSpacesTotal}
      </span>
      &nbsp;
      <span>({percentageAvailable}%)</span>
      <Chart displayBig={shouldDisplayBig} />
    </div>
  )
}
